module.exports = __webpack_public_path__ + "img/logo-wordmark.7955262e.svg";